import './global.d';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FlagProvider } from '@unleash/proxy-client-react';
import 'assets/css/maf-connect.css';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { UNLEASH_CLIENT_KEY, UNLEASH_ENV, UNLEASH_PROXY_URI } from 'shared/consts/config';
import { toast } from 'shared/hooks/useToast';
import { router } from 'shared/router';
import { Toaster } from 'tremor/components/Toaster';

const config = {
  url: UNLEASH_PROXY_URI,
  clientKey: UNLEASH_CLIENT_KEY,
  refreshInterval: 60,
  appName: 'xconnect-ui',
  environment: UNLEASH_ENV,
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error: any) => {
      if (error.response?.status === 420) {
        toast({ title: 'Client ID does not match', variant: 'error' });
      } else if (error.response?.status === 421) {
        toast({ title: 'Issuer does not match', variant: 'error' });
      }
    },
  }),
});
const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <FlagProvider config={config}>
        <Toaster />
        <RouterProvider router={router} />
      </FlagProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
